<template>
  <div>
    <button
      type="button"
      class="text-white px-3 py-4 lg:py-2 flex items-center text-xs font-bold cursor-pointer bg-transparent border-0"
      ref="btnDropdownRef"
      v-on:click="toggleDropdown($event)"
    >
      <i class="fas fa-microchip text-lg leading-lg mr-2 text-indigo-300"></i>
      WaveEdge
      <i class="fas fa-chevron-down ml-1 text-xs"></i>
    </button>
    <div
      ref="popoverDropdownRef"
      class="nav-dropdown-menu bg-blueGray-800 text-base z-50 float-left py-2 list-none text-left rounded shadow-lg min-w-48 border border-blueGray-700"
      v-bind:class="{
        hidden: !dropdownPopoverShow,
        block: dropdownPopoverShow,
      }"
    >
      <router-link
        to="/waveedge"
        class="text-sm py-2 px-4 font-semibold block w-full whitespace-nowrap bg-transparent text-lightBlue-300 hover:bg-blueGray-700 hover:text-white"
        @click="closeDropdown"
      >
        WaveEdge
      </router-link>
      <router-link
        to="/pumplink7"
        class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-200 hover:bg-blueGray-700 hover:text-white"
        @click="closeDropdown"
      >
        PumpLink7
      </router-link>
      <router-link
        to="/blenderlink7"
        class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-200 hover:bg-blueGray-700 hover:text-white"
        @click="closeDropdown"
      >
        BlenderLink7
      </router-link>
    </div>
  </div>
</template>

<script>
import { createPopper } from "@popperjs/core";

export default {
  data() {
    return {
      dropdownPopoverShow: false,
    };
  },
  methods: {
    toggleDropdown: function (event) {
      event.preventDefault();
      if (this.dropdownPopoverShow) {
        this.dropdownPopoverShow = false;
      } else {
        this.dropdownPopoverShow = true;
        createPopper(this.$refs.btnDropdownRef, this.$refs.popoverDropdownRef, {
          placement: "bottom-start",
        });
      }
    },
    closeDropdown() {
      this.dropdownPopoverShow = false;
    },
  },
};
</script>
